require('./pickup-delivery-select/pickup-delivery-select.scss');
var BaseViews = require('../base');
var Button = require('treeline-shared-components/button.js');
var SpinnerButton = require('treeline-shared-components/spinner-button');
var LocationsList = require('../locations-list');
var DeliveryPostalCodeForm = require('../delivery-postal-code-form');
var lsCache = require('lscache');

var PickupDeliverySelect = BaseViews.LayoutView.extend({
    template: require('./pickup-delivery-select/pickup-delivery-select.html'),
    className: 'fmcy-plugin-bootstrap fmcy-pickup-delivery-select container-fluid',
    initialize: function (options) {
        var self = this;
        this.options = _.defaults(
            options || {},
            {
                _appChannel: null,
                _menuState: null,
                referrer: 'entry'
            }
        );
        this.deliveryModel = this.options._appChannel.request('cart:get:delivery:model');
        this.deliveryAddressModel = this.deliveryModel.get('cartDeliveryAddressModel');
        this.deliveryAvailableAnywhere = this.options._appChannel.request('validate:is:delivery:available:anywhere');
    },
    regions : {
      fmcyPickupDeliverySelectTabRegion: '.fmcy-pickup-delivery-select-tab-region',
      fmcyPickupDeliverySelectedContentRegion: '.fmcy-pickup-delivery-selected-content-region',
      fmcyPickupDeliveryContinueButtonRegion: '.fmcy-continue-button-region'
    },
    ui : {
      expandedRow: '.fmcy-pickup-delivery-select-expanded-row',
      continueButtonSection: '.fmcy-delivery-select-continue-button-bar'
    },
    _renderContinueButton: function () {
        var self = this;
        this.ui.continueButtonSection.css('display', 'block');
        var continueButton = new SpinnerButton.SpinnerButton({
            label: 'Start shopping',
            multiClick: false,
            classNames: 'fmcy-continue-btn',
            theme: SpinnerButton.THEMES.PRIMARY,
            size: SpinnerButton.SIZES.LARGE,
            onClickedCallback: function () {
                self.trigger('location:selected', null);
            }
        });
        this.fmcyPickupDeliveryContinueButtonRegion.show(continueButton);
    },
    _hideContinueButton: function() {
        this.ui.continueButtonSection.css('display', 'none');
    },
    _renderCheckDeliveryLayout: function () {
        var self = this;
        var postCodeError = false;
        var cartdeliveryAddressModel = this.deliveryModel.get('cartDeliveryAddressModel');

        if (currentSelectedLocationSlug == cartdeliveryAddressModel.get('local_delivery_confirmed_farm_location_slug') &&
        cartdeliveryAddressModel.get('local_delivery_postal_code_verified') != null) {
            this._renderContinueButton();
        } 

        if (cartdeliveryAddressModel.get('local_delivery_postal_code_verified') != cartdeliveryAddressModel.get('local_delivery_postal_code')) {
            postCodeError = true;
        }

        this.deliveryPostalCodeForm = new DeliveryPostalCodeForm({
            _appChannel: this.options._appChannel,
            error: postCodeError
        })

        this.deliveryPostalCodeForm.on('show:continue:button', function () {
            self._renderContinueButton();
        });

        this.deliveryPostalCodeForm.on('hide:continue:button', function () {
            self._hideContinueButton();
        });

        this.fmcyPickupDeliverySelectedContentRegion.show(this.deliveryPostalCodeForm);

        var currentSelectedLocationSlug = this.options._appChannel.request('get:filter:location:details').get('slug');        
    },
    _renderLocationList: function() {
      var self = this;
      this.locationsList = new LocationsList({
        collection: this.options._appChannel.request('get:locations'),
        resizeHeightToScreenSize: false,
        clickableLocationInfo: true
      });
      this.locationsList.on('item:clicked', function(model) {
        self.options._appChannel.trigger('location:selected', model.get('slug'), self.options.referrer);
        self.trigger('location:selected', model);
      });
      this.fmcyPickupDeliverySelectedContentRegion.show(this.locationsList);
      this._hideContinueButton();
    },
    _renderLocationTabs: function() {
        var self = this;
        if (self._tabs) {
            return;
        }

        var tabItems = [
                {
                    id: 'pickup',
                    labelText: 'Instore Pickup'
                }
            ];


        if (this.deliveryAvailableAnywhere) {
            tabItems.push({
                    id: 'local_delivery',
                    labelText: 'Delivery'
                });
        }

        self._tabs = new (require('treeline-shared-components/tabs'))({
            style: 'tabs',
            tabs: tabItems
        });
        self._tabs.on('tab:clicked', function (tabModel) {
          var local_delivery_method = tabModel.id;
          self.deliveryAddressModel.set('local_delivery_method', local_delivery_method);
          if (tabModel.id == 'pickup') {
            // pickup tab clicked...
            self._renderLocationList();
          } else {
            // delivery tab clicked...
            self._renderCheckDeliveryLayout();
          }
          lsCache.set('cartDeliveryAddressModel', self.deliveryAddressModel.toJSON(), 14400000);
          self.options._appChannel.trigger('cart:set:delivery:method', local_delivery_method);
        });
        self.fmcyPickupDeliverySelectTabRegion.show(self._tabs);
    },
    onRender: function () {
        this._renderLocationTabs();
        if (this.options.delivery_method !== null && (this.options.delivery_method == 'local_delivery' || this.options.delivery_method == 'pickup')) {
            this.deliveryAddressModel.set('local_delivery_method', this.options.delivery_method);
            lsCache.set('cartDeliveryAddressModel', this.deliveryAddressModel.toJSON(), 14400000);
            this.options._appChannel.trigger('cart:set:delivery:method', local_delivery_method);
        }

        var local_delivery_method = this.deliveryAddressModel.get('local_delivery_method');

        if (local_delivery_method && 
            local_delivery_method == 'local_delivery' &&
            this.deliveryAvailableAnywhere) {
            this._tabs.setActiveTabById('local_delivery');
            this._renderCheckDeliveryLayout();
        } else {
            this._tabs.setActiveTabById('pickup');
            this._renderLocationList();
        }
    }
});
module.exports = PickupDeliverySelect;



/** WEBPACK FOOTER **
 ** ./assets/js/common/entry-flow/pickup-delivery-select.js
 **/